
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export function AuthError() {
  const navigate = useNavigate();
  
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Authentication Error</AlertTitle>
      <AlertDescription>
        Please login again to access this page.
      </AlertDescription>
      <div className="flex gap-2 mt-4">
        <Button variant="outline" onClick={() => navigate('/admin/login')}>
          Login Page
        </Button>
      </div>
    </Alert>
  );
}
